import { fetchTopics } from "../pages/tatvaShots/service";
import useStore from "../store/useStore";

const useTopics = () => {
  const { setTatvaShots } = useStore();

  const getTopics = async () => {
    try {
      const topics = await fetchTopics();
      setTatvaShots({ topics });
    } catch (err) {
      // Handle error
    }
  };

  return { getTopics };
};

export default useTopics;
